import { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertProps, AlertTitle, Collapse } from '@mui/material';

import { IconButton } from '@components/base';

export type ErrorMessageProps = {
  action?: AlertProps['action'];
  alertMessage?: string;
  alertTitle?: string;
  error: Error;
  hideStack?: boolean;
  severity?: AlertProps['severity'];
};

export const ErrorMessage: FC<ErrorMessageProps> = ({
  action,
  alertMessage,
  alertTitle,
  error: { message, name, stack },
  hideStack,
  severity = 'error',
}) => {
  const { t } = useTranslation();

  const [expanded, setExpanded] = useState(false);

  return (
    <Alert
      action={
        <Fragment>
          {action}
          {stack && !hideStack ? (
            <IconButton
              color='inherit'
              icon={expanded ? 'expandLess' : 'expandMore'}
              onClick={() => setExpanded(prev => !prev)}
              title={expanded ? t('collapse') : t('expand')}
            />
          ) : undefined}
        </Fragment>
      }
      severity={severity}
    >
      <AlertTitle>{alertTitle || name}</AlertTitle>
      {alertMessage || message}
      {stack && !hideStack && (
        <Collapse in={expanded}>
          <pre>{stack}</pre>
        </Collapse>
      )}
    </Alert>
  );
};
